module.exports = __webpack_public_path__ + "img/ttshop_dsh1.b6432c8c.svg";